import React from 'react'

const Data = () => {
  return (
    <div className="home__data">
        <h1 className='home__title'>Khaled Abdulrahman <span>👋</span></h1>
        <h3 className="home__subtitle">Software Developer</h3>
        <p className="home__description">I'm Software Developer , Based in Muscat - Oman, and I'm very passionate and dedicated to my work.</p> 
        <a href="#contact" className="button button--flex">Contact me<i class="uil uil-message" style={{'margin-left':'10px'}}></i> </a>
    </div>
  )
}

export default Data